'use client';

import { useEffect, useMemo } from 'react';
import type { RouteMetaPayload } from '../../_libs/site-shell/routeMeta';
import { resolveRouteMetaDisableFooterDisplayAd } from '../../_libs/site-shell/routeMeta';
import { useRouteMetaRegistration } from './RouteMetaContext';

export function RouteMeta({
  metaProps,
  quoteTitlesByTab,
  pageTargeting,
  disableFooterDisplayAd,
  disableStickyFooter,
  disableRaptiveFooter,
  article,
  post,
  term,
  disablePageTracking,
}: RouteMetaPayload) {
  const { pathname, registerRouteMeta } = useRouteMetaRegistration();
  const footerDisplayAdDisabled =
    disableFooterDisplayAd !== undefined ||
    disableStickyFooter !== undefined ||
    disableRaptiveFooter !== undefined
      ? resolveRouteMetaDisableFooterDisplayAd({
          disableFooterDisplayAd,
          disableStickyFooter,
          disableRaptiveFooter,
        })
      : undefined;

  const payload = useMemo<RouteMetaPayload | null>(() => {
    const hasPayload =
      metaProps ||
      quoteTitlesByTab ||
      pageTargeting ||
      footerDisplayAdDisabled !== undefined ||
      article ||
      post ||
      term ||
      disablePageTracking !== undefined;

    return hasPayload
      ? {
          metaProps,
          quoteTitlesByTab,
          pageTargeting,
          disableFooterDisplayAd: footerDisplayAdDisabled,
          article,
          post,
          term,
          disablePageTracking,
        }
      : null;
  }, [
    metaProps,
    quoteTitlesByTab,
    pageTargeting,
    footerDisplayAdDisabled,
    article,
    post,
    term,
    disablePageTracking,
  ]);

  registerRouteMeta(payload);

  useEffect(() => {
    return () => registerRouteMeta(null, pathname);
  }, [registerRouteMeta, pathname]);

  return null;
}
